import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ProfileContactSection from '/component/partial/profile/ProfileContactSection';
import {withTranslation} from '/provider/TranslationProvider';
import {
  emailById,
  nameById,
  phoneNumberById,
  urlDetailsById,
} from '/redux/selector/candidate.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      name: nameById,
      accountEmail: emailById,
      phoneNumber: phoneNumberById,
      urlDetails: urlDetailsById,
    }),
  ),
  withTranslation('screen.candidateProfile.section.contact'),
)(ProfileContactSection);
